import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberFirearmForm from '../../../components/forms/MemberFirearmForm';
import { useMemberFirearmApi } from '../../../hooks/useMemberFirearmApi';
import { useNavigate, useParams } from 'react-router-dom';
import { MemberFirearmDTO } from '../../../services/apiClient';

const MemberFirearmEdit: React.FC = () => {
  const { getById, edit } = useMemberFirearmApi();
  const [entityData, setEntityData] = useState<MemberFirearmDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearms', href: '/admin/memberfirearms' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching MemberFirearm data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate(-1);
    } catch (error) {
      console.error('Error updating MemberFirearm:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberfirearms"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin','User']}
      requiredPermission='Manage.MemberFirearm.Edit'
    >
        {entityData ? (
          <MemberFirearmForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate(-1)}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberFirearmEdit;